import * as React from 'react';
import { ISupportTicket } from '../../../../models/Support/ISupportTicket';
import { InternalTicketModal } from './InternalTicketModal';
import type { NewTicketDraftAccount, NewTicketMode } from './newTicketDraft';
import { OutboundTicketModal } from './OutboundTicketModal';

export { InternalTicketModal } from './InternalTicketModal';
export { OutboundTicketModal } from './OutboundTicketModal';

export interface NewTicketModalProps {
	/** Prefills the account (and its CSM) — set when launched from the account details page or an account-scoped inbox. */
	defaultAccount?: NewTicketDraftAccount;
	defaultMailboxId?: string;
	/** Chosen before the dialog opens, because the two modes collect different things. */
	mode: NewTicketMode;
	onClose: () => void;
	/** When provided the host owns post-create navigation; otherwise the success toast links to the ticket. */
	onCreated?: (ticket: ISupportTicket) => void;
}

export const NewTicketModal: React.FC<NewTicketModalProps> = ({ mode, ...props }) =>
	mode === 'outbound' ? <OutboundTicketModal {...props} /> : <InternalTicketModal {...props} />;
